import { MergeForecastSettingsMutation } from "~/gql/mutations/forecast.generated";
import { GetForecastSettingsQuery } from "~/gql/queries/forecast.generated";

export const forecastSettingsEndpoints = {
	GetForecastSettings: {
		providesTags: ["ForecastSettings"] as AddTagTypes,
		transformResponse: (res: GetForecastSettingsQuery) => res
	},
	MergeForecastSettings: {
		invalidatesTags: ["ForecastSettings"] as AddTagTypes,
		transformResponse: (res: MergeForecastSettingsMutation) => res
	}
};
